export default __webpack_public_path__ + "static/media/sayf.fdf000d7.svg";